import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ChatAvatar from 'components/shared/ChatAvatar'
import Timestamp from './Timestamp'
import { getActivityTimestamp } from 'shared/utils/time'

const BubbleWrapper = styled.div`
  padding: 16px; 
  margin-top: ${props => props.endOfBlock ? '16px' : '4px' };
  border-radius: 8px;
  width: ${props => props.width};
  height: auto;
  max-width: 85.5%;
  min-width: 100px;
  
  font-size: 14rem;
  text-align: left;  
  
  color: #353A52;
  background-color: ${props => props.isLeft ? 'rgba(144, 161, 176, 0.16)' : 'rgba(144, 161, 176, 0.32)' };
  
  align-self: ${props => props.isLeft ? 'flex-start' : 'flex-end'};
  position: relative;
  text-rendering: optimizelegibility;
  word-break: break-word;
  cursor: default;
`

const avatarPosition = props => props.isLeft
  ? css`
  left: -60px;
`
  : css`
  right: -60px;
`
const AvatarWrapper = styled.div`
  position: absolute;
  top: -8px;
  
  ${avatarPosition}
`

const Bubble = ({
  width,
  isLeft,
  avatar,
  endOfBlock,
  timestamp,
  stampStyle,
  children
}) => (
  <BubbleWrapper
    isLeft={isLeft}
    endOfBlock={endOfBlock}
    width={width}
  >
    {(stampStyle !== 'none') && <Timestamp stampType={stampStyle} time={timestamp} /> }
    { children }
    { !!avatar && 
    <AvatarWrapper isLeft={isLeft}>
      <ChatAvatar actor={avatar}/>
    </AvatarWrapper>
    }
  </BubbleWrapper>
)
Bubble.propTypes = {
  width: PropTypes.string,
  isLeft: PropTypes.bool,
  avatar: PropTypes.any,
  endOfBlock: PropTypes.bool,
  timestamp: PropTypes.instanceOf(Date),
  stampStyle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ])
}

Bubble.defaultTypes ={
  stampStyle: 'text'
}

export default Bubble
